import styled, { css } from "styled-components";
import buildColor from "@fdr/static-ui/ColorPalette";
import { fontCondensed } from "@fdr/static-ui/Typography";

interface ProductLinkProps {
  isAvailableForState: boolean;
}

export const ProductLink = styled.a<ProductLinkProps>`
  padding: 11px 0;
  display: flex;
  justify-content: space-between;

  &:not(:last-child) {
    border-bottom: 1px solid ${buildColor("grey", "L2")};
  }

  ${({ isAvailableForState }) =>
    !isAvailableForState &&
    css`
      a {
        width: auto;
      }
    `}
`;

export const UnavailableText = styled.span`
  color: ${buildColor("orange", "D2")};
  text-transform: uppercase;
  font-family: ${fontCondensed};
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  display: flex;
  align-items: center;
  letter-spacing: 1px;
`;
